import { render, staticRenderFns } from "./ModalDocument.vue?vue&type=template&id=2afa8f92&scoped=true&"
import script from "./ModalDocument.vue?vue&type=script&lang=js&"
export * from "./ModalDocument.vue?vue&type=script&lang=js&"
import style0 from "./ModalDocument.vue?vue&type=style&index=0&id=2afa8f92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afa8f92",
  null
  
)

export default component.exports